import styles from "./NovoCertificado.module.css";
import { Field, Form, Formik } from "formik";
import Button from "../../../../../components/components-ui/Button/Button";
import { Col, Grid } from "../../../../../components/Grid";
import {
  customStyles,
  SelectSearch,
} from "../../../../../components/components-ui/SelectSearch/SelectSearch";
import api from "../../../../../services/Api";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Select from "react-select";
import { Table } from "../../../../../components/Table";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";
import Loading from "../../../../../components/components-ui/Loading/Loading";
import CustomConfirmAlert from "../../../../../components/components-ui/CustomConfirmAlert/CustomConfirmAlert";
import InputClear from "../../../../../components/components-ui/InputClear/InputClear";

const API_CRIAR_CERTIFICADOS = "/certificados/create";

function NovoCertificado({
  recarregarCertificados,
  closeModal,
  modelosCertificados,
}) {
  const [loading, setLoading] = useState(false);

  const criarCertificados = async (values) => {
    const data = {
      numeroCertificadoDe: values?.numeroCertificadoDe || null,
      numeroCertificadoAte: values?.numeroCertificadoAte || null,
      modelo: values?.modelo || null,
    };

    CustomConfirmAlert({
      subtitle: `Deseja realmente criar os certificados de ${data.numeroCertificadoDe} até ${data.numeroCertificadoAte} para o modelo ${data.modelo}`,
      labelBtnConfirmar: "Criar Certificados",
      onConfirm: async () => {
        const promise = api
          .post(API_CRIAR_CERTIFICADOS, data)
          .then((response) => {
            const res = response.data;
            if (res.error !== 0) {
              throw new Error(res.msg || `Erro: ${res.error}`);
            }
            return response;
          });

        toast.promise(promise, {
          pending: "Criando certificados...",
          success: {
            render({ data }) {
              const res = data.data;
              if (res.error === 0) {
                return res.msg || "Certificados criados com sucesso!";
              }
              throw new Error(res.msg || `Erro: ${res.error}`);
            },
          },
          error: {
            render({ data }) {
              return data?.message || "Erro ao criar certificados";
            },
          },
        });

        try {
          const response = await promise;
          const res = response.data;
          recarregarCertificados();
          closeModal();
        } catch (error) {
          console.error("Erro ao criar certificados: ", error);
        }
      },
    });
  };

  const validationSchema = Yup.object().shape({
    numeroCertificadoDe: Yup.string().nullable().required("Campo Obrigatório"),
    numeroCertificadoAte: Yup.string().nullable().required("Campo Obrigatório"),
    modelo: Yup.string().nullable().required("Campo Obrigatório"),
  });

  return (
    <div className={styles.modal_container}>
      <h2 style={{ textAlign: "center" }}>Novos Certificados</h2>
      <Formik
        initialValues={{
          numeroCertificadoDe: "",
          numeroCertificadoAte: "",
          modelo: null,
        }}
        validationSchema={validationSchema}
        validateOnBlur
        validateOnChange
        enableReinitialize={true}
        onSubmit={(values) => criarCertificados(values)}
      >
        {({
          errors,
          touched,
          values,
          isSubmitting,
          isValid,
          setFieldValue,
        }) => (
          <Form>
            {loading ? (
              <div className={styles.loading_container}>
                <Loading display={loading ? "block" : "none"} />
              </div>
            ) : (
              <div>
                <Grid>
                  <Col size={4}>
                    <label>Nº Certificado De: </label>
                    <Field type="text" name="numeroCertificadoDe">
                      {({ field }) => (
                        <InputClear
                          type="text"
                          onClick={() =>
                            setFieldValue("numeroCertificadoDe", "")
                          }
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.numeroCertificadoDe &&
                    touched.numeroCertificadoDe ? (
                      <span className={styles.alertError}>
                        {errors.numeroCertificadoDe}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={4}>
                    <label>Nº Certificado Ate: </label>
                    <Field type="text" name="numeroCertificadoAte">
                      {({ field }) => (
                        <InputClear
                          type="text"
                          onClick={() =>
                            setFieldValue("numeroCertificadoAte", "")
                          }
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.numeroCertificadoAte &&
                    touched.numeroCertificadoAte ? (
                      <span className={styles.alertError}>
                        {errors.numeroCertificadoAte}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={4}>
                    <label>Modelo</label>
                    <Field
                      name="modelo"
                      component={SelectSearch}
                      options={modelosCertificados.map((values) => ({
                        label: values?.descricao,
                        value: values?.ID,
                      }))}
                    />
                    {errors.modelo && touched.modelo ? (
                      <span className={styles.alertError}>{errors.modelo}</span>
                    ) : null}
                  </Col>
                </Grid>
                <div className={styles.buttons_container}>
                  <Button
                    title="Salvar"
                    type="submit"
                    disabled={isSubmitting}
                    className={styles.button_sm}
                  />
                  <Button
                    title="Fechar"
                    type="button"
                    disabled={isSubmitting}
                    onClick={() => closeModal()}
                    color={"secondary"}
                    className={styles.button_sm}
                  />
                </div>
                {/* {isSubmitting && (
                <div className={styles.loading_container}>
                  <Loading display={isSubmitting ? "block" : "none"} />
                </div>
              )} */}
              </div>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default NovoCertificado;
